// src/ThemeContext.js
import React, { createContext, useState, useContext } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

// Create context
const ThemeContext = createContext();

export const useThemeContext = () => useContext(ThemeContext);

// Define custom colors for themes
const themeColors = {
  blue: '#1976d2',
};

export const ThemeContextProvider = ({ children }) => {
  const [primaryColor, setPrimaryColor] = useState(themeColors.blue);

  const toggleTheme = () => {
    setPrimaryColor((prevColor) =>
      prevColor === themeColors.blue ? themeColors.blue : themeColors.orange
    );
  };

  const theme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
    },
  });

  return (
    <ThemeContext.Provider value={{ toggleTheme, primaryColor }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};
